import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../../tasks/baseFormComponent/baseForm.component';
import { CustomFieldDTO } from '../../api/plyca-dtos-v2';
import { Component, OnInit, Optional, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { searchGenericComponent, SearchSettingDTOModal } from '../../components/search/searchGeneric.component';
import { formElementComponent } from '../../components/forms/formElement.component'
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';

export class CustomFieldModel {

  dto: CustomFieldDTO;
  ui: {
    'origin'?: string,
    'destination'?: string,
    'type'?: boolean,
  }
  helpTags?: string[];
}
// templateUrl: 'customField.edition.template.html'
@Component({
  selector: 'customField-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
})
export class CustomFieldEditionComponent
  extends BaseFormComponent<CustomFieldDTO, CustomFieldModel>
  implements OnInit {
  private identifier: string;

  // @ViewChild('TEST_EXTENSION') TEST_EXTENSION: TemplateRef<any>;

  constructor(
    elem: ElementRef,
    public helpService: HelpService,
    @Optional() protected activatedRoute: ActivatedRoute
  ) {
    super(elem);
    // obtener identificador de comunicacion
    this.subscribe(

      this.activatedRoute.params
        .pipe(tap(params => (this.identifier = params['id'])))



    );


    this.subscribe(this.helpService.showContextHelpObservable(HelpType.CUSTOMFIELDS));
  }

  getFormSettingURL(): string {
    return 'admin/customFieldISettings.json';
  }

  getServiceURL(): string {
    return this.configuration.CUSTOMFIELDS_SERVICE_URL;
  }

  getObjectIdentifier(): string {
    return this.identifier;
  }

  dtoToModel(dto: CustomFieldDTO): Observable<CustomFieldModel> {
    let model = new CustomFieldModel();
    model.dto = dto;
    model.ui = {};
    // El componente p-chips no maneja paths, solo fields
    model.helpTags = dto.display.helpTags;

    if (!dto.owner.resource || !dto.owner.resource.identifier || !dto.owner.resource.identifier.endsWith('PROJECT<>ACTION_OBJ_TYPE')) {
      model.ui.destination = '1';
    } else if (dto.destination.location && dto.destination.location.table) {
      model.ui.destination = '2';
    }


    if (dto.origin.table && dto.origin.table.identifier) {
      model.ui.origin = '1';
    } else if (dto.origin.listName) {
      model.ui.origin = '2';
    } else if (dto.origin.query) {
      model.ui.origin = '3';
    } else if (dto.origin.attribute && dto.origin.attribute.identifier) {
      model.ui.origin = '4';
    } else if (dto.origin.search && dto.origin.search.identifier) {
      model.ui.origin = '5';
    }
    return of(model);
  }

  modelToDTO(model: CustomFieldModel): CustomFieldDTO {
    if (model.dto.owner.documentClasses) {
      model.dto.owner.documentClasses.forEach(dc => {
        delete dc['_parent'];
      });
    }
    if (model.dto.origin.search && !model.dto.origin.search.identifier) {
      model.dto.origin.search = null;
    }

    // El componente p-chips no maneja paths, solo fields
    if (model.helpTags) {
      model.dto.display.helpTags = model.helpTags;
    }

    return model.dto;
  }

  getTitle(model: CustomFieldModel): string {
    if (model) {
      return model.dto.identifier + ' - ' + model.dto.description;
    } else {
      return 'Nuevo grupo';
    }
  }


  // getProjectId(): string {
  //   return this.model.dto.project.identifier;
  // }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'CustomField.Title';
    headerInfo.titleIcon = 'fas fa-envelope-open-text';
    // TODO pendiente de extraer datos para nueva comm
    // headerInfo.project = this.model.dto.project;
    return headerInfo;
  }

  initHeaderActions() {

    this.addBackAction();
  }

  openDocumentClassSelector() {
    let contextSearch = new SearchSettingDTOModal('DOCUMENTCLASS', true);
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    let ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose, documentClass => {
      if (!this.model.dto.owner.documentClasses) {
        this.model.dto.owner.documentClasses = [];
      }
      this.model.dto.owner.documentClasses.push(documentClass);
    });

  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.readonly = true;
    formConfig.functions.push({
      identifier: 'openDocumentClassSelector',
      fn: this.openDocumentClassSelector
    });
    return of(formConfig);

  }


}
